"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CoordinateSequenceFactory = _interopRequireDefault(require("./CoordinateSequenceFactory"));

var _LineString = _interopRequireDefault(require("./LineString"));

var _Geometry = _interopRequireDefault(require("./Geometry"));

var _hasInterface = _interopRequireDefault(require("../../../../hasInterface"));

var _Coordinate = _interopRequireDefault(require("./Coordinate"));

var _Point = _interopRequireDefault(require("./Point"));

var _Polygon = _interopRequireDefault(require("./Polygon"));

var _MultiPoint = _interopRequireDefault(require("./MultiPoint"));

var _GeometryEditor = _interopRequireDefault(require("./util/GeometryEditor"));

var _LinearRing = _interopRequireDefault(require("./LinearRing"));

var _CoordinateArraySequenceFactory = _interopRequireDefault(require("./impl/CoordinateArraySequenceFactory"));

var _MultiPolygon = _interopRequireDefault(require("./MultiPolygon"));

var _CoordinateSequences = _interopRequireDefault(require("./CoordinateSequences"));

var _CoordinateSequence = _interopRequireDefault(require("./CoordinateSequence"));

var _GeometryCollection = _interopRequireDefault(require("./GeometryCollection"));

var _PrecisionModel = _interopRequireDefault(require("./PrecisionModel"));

var _Serializable = _interopRequireDefault(require("../../../../java/io/Serializable"));

var _Assert = _interopRequireDefault(require("../util/Assert"));

var _MultiLineString = _interopRequireDefault(require("./MultiLineString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GeometryFactory =
/*#__PURE__*/
function () {
  function GeometryFactory() {
    _classCallCheck(this, GeometryFactory);

    GeometryFactory.constructor_.apply(this, arguments);
  }

  _createClass(GeometryFactory, [{
    key: "toGeometry",
    value: function toGeometry(envelope) {
      if (envelope.isNull()) {
        return this.createPoint();
      }

      if (envelope.getMinX() === envelope.getMaxX() && envelope.getMinY() === envelope.getMaxY()) {
        return this.createPoint(new _Coordinate.default(envelope.getMinX(), envelope.getMinY()));
      }

      if (envelope.getMinX() === envelope.getMaxX() || envelope.getMinY() === envelope.getMaxY()) {
        return this.createLineString([new _Coordinate.default(envelope.getMinX(), envelope.getMinY()), new _Coordinate.default(envelope.getMaxX(), envelope.getMaxY())]);
      }

      return this.createPolygon(this.createLinearRing([new _Coordinate.default(envelope.getMinX(), envelope.getMinY()), new _Coordinate.default(envelope.getMinX(), envelope.getMaxY()), new _Coordinate.default(envelope.getMaxX(), envelope.getMaxY()), new _Coordinate.default(envelope.getMaxX(), envelope.getMinY()), new _Coordinate.default(envelope.getMinX(), envelope.getMinY())]), null);
    }
  }, {
    key: "createLineString",
    value: function createLineString() {
      if (arguments.length === 0) {
        return this.createLineString(this.getCoordinateSequenceFactory().create([]));
      } else if (arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var coordinates = arguments[0];
          return this.createLineString(coordinates !== null ? this.getCoordinateSequenceFactory().create(coordinates) : null);
        } else if ((0, _hasInterface.default)(arguments[0], _CoordinateSequence.default)) {
          var _coordinates = arguments[0];
          return new _LineString.default(_coordinates, this);
        }
      }
    }
  }, {
    key: "createMultiLineString",
    value: function createMultiLineString() {
      if (arguments.length === 0) {
        return new _MultiLineString.default(null, this);
      } else if (arguments.length === 1) {
        var lineStrings = arguments[0];
        return new _MultiLineString.default(lineStrings, this);
      }
    }
  }, {
    key: "buildGeometry",
    value: function buildGeometry(geomList) {
      var geomClass = null;
      var isHeterogeneous = false;
      var hasGeometryCollection = false;

      for (var i = geomList.iterator(); i.hasNext();) {
        var geom = i.next();
        var partClass = geom.getClass();

        if (geomClass === null) {
          geomClass = partClass;
        }

        if (partClass !== geomClass) {
          isHeterogeneous = true;
        }

        if (geom instanceof _GeometryCollection.default) hasGeometryCollection = true;
      }

      if (geomClass === null) {
        return this.createGeometryCollection();
      }

      if (isHeterogeneous || hasGeometryCollection) {
        return this.createGeometryCollection(GeometryFactory.toGeometryArray(geomList));
      }

      var geom0 = geomList.iterator().next();
      var isCollection = geomList.size() > 1;

      if (isCollection) {
        if (geom0 instanceof _Polygon.default) {
          return this.createMultiPolygon(GeometryFactory.toPolygonArray(geomList));
        } else if (geom0 instanceof _LineString.default) {
          return this.createMultiLineString(GeometryFactory.toLineStringArray(geomList));
        } else if (geom0 instanceof _Point.default) {
          return this.createMultiPoint(GeometryFactory.toPointArray(geomList));
        }

        _Assert.default.shouldNeverReachHere("Unhandled class: " + geom0.getClass().getName());
      }

      return geom0;
    }
  }, {
    key: "createMultiPointFromCoords",
    value: function createMultiPointFromCoords(coordinates) {
      return this.createMultiPoint(coordinates !== null ? this.getCoordinateSequenceFactory().create(coordinates) : null);
    }
  }, {
    key: "createPoint",
    value: function createPoint() {
      if (arguments.length === 0) {
        return this.createPoint(this.getCoordinateSequenceFactory().create([]));
      } else if (arguments.length === 1) {
        if (arguments[0] instanceof _Coordinate.default) {
          var coordinate = arguments[0];
          return this.createPoint(coordinate !== null ? this.getCoordinateSequenceFactory().create([coordinate]) : null);
        } else if ((0, _hasInterface.default)(arguments[0], _CoordinateSequence.default)) {
          var coordinates = arguments[0];
          return new _Point.default(coordinates, this);
        }
      }
    }
  }, {
    key: "getCoordinateSequenceFactory",
    value: function getCoordinateSequenceFactory() {
      return this._coordinateSequenceFactory;
    }
  }, {
    key: "createPolygon",
    value: function createPolygon() {
      if (arguments.length === 0) {
        return this.createPolygon(null, null);
      } else if (arguments.length === 1) {
        if ((0, _hasInterface.default)(arguments[0], _CoordinateSequence.default)) {
          var shell = arguments[0];
          return this.createPolygon(this.createLinearRing(shell));
        } else if (arguments[0] instanceof Array) {
          var _shell = arguments[0];
          return this.createPolygon(this.createLinearRing(_shell));
        } else if (arguments[0] instanceof _LinearRing.default) {
          var _shell2 = arguments[0];
          return this.createPolygon(_shell2, null);
        }
      } else if (arguments.length === 2) {
        var _shell3 = arguments[0],
            holes = arguments[1];
        return new _Polygon.default(_shell3, holes, this);
      }
    }
  }, {
    key: "getSRID",
    value: function getSRID() {
      return this._SRID;
    }
  }, {
    key: "createGeometryCollection",
    value: function createGeometryCollection() {
      if (arguments.length === 0) {
        return new _GeometryCollection.default(null, this);
      } else if (arguments.length === 1) {
        var geometries = arguments[0];
        return new _GeometryCollection.default(geometries, this);
      }
    }
  }, {
    key: "createGeometry",
    value: function createGeometry(g) {
      var editor = new _GeometryEditor.default(this);
      return editor.edit(g, new (
      /*#__PURE__*/
      function () {
        function _class() {
          _classCallCheck(this, _class);
        }

        _createClass(_class, [{
          key: "edit",
          value: function edit() {
            if (arguments.length === 2 && arguments[1] instanceof _Geometry.default && (0, _hasInterface.default)(arguments[0], _CoordinateSequence.default)) {
              var coordSeq = arguments[0],
                  geometry = arguments[1];
              return this._coordinateSequenceFactory.create(coordSeq);
            }
          }
        }]);

        return _class;
      }())());
    }
  }, {
    key: "getPrecisionModel",
    value: function getPrecisionModel() {
      return this._precisionModel;
    }
  }, {
    key: "createLinearRing",
    value: function createLinearRing() {
      if (arguments.length === 0) {
        return this.createLinearRing(this.getCoordinateSequenceFactory().create([]));
      } else if (arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var coordinates = arguments[0];
          return this.createLinearRing(coordinates !== null ? this.getCoordinateSequenceFactory().create(coordinates) : null);
        } else if ((0, _hasInterface.default)(arguments[0], _CoordinateSequence.default)) {
          var _coordinates2 = arguments[0];
          return new _LinearRing.default(_coordinates2, this);
        }
      }
    }
  }, {
    key: "createMultiPolygon",
    value: function createMultiPolygon() {
      if (arguments.length === 0) {
        return new _MultiPolygon.default(null, this);
      } else if (arguments.length === 1) {
        var polygons = arguments[0];
        return new _MultiPolygon.default(polygons, this);
      }
    }
  }, {
    key: "createMultiPoint",
    value: function createMultiPoint() {
      if (arguments.length === 0) {
        return new _MultiPoint.default(null, this);
      } else if (arguments.length === 1) {
        if (arguments[0] instanceof Array) {
          var point = arguments[0];
          return new _MultiPoint.default(point, this);
        } else if ((0, _hasInterface.default)(arguments[0], _CoordinateSequence.default)) {
          var coordinates = arguments[0];

          if (coordinates === null) {
            return this.createMultiPoint(new Array(0).fill(null));
          }

          var points = new Array(coordinates.size()).fill(null);

          for (var i = 0; i < coordinates.size(); i++) {
            var ptSeq = this.getCoordinateSequenceFactory().create(1, coordinates.getDimension());

            _CoordinateSequences.default.copy(coordinates, i, ptSeq, 0, 1);

            points[i] = this.createPoint(ptSeq);
          }

          return this.createMultiPoint(points);
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryFactory;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Serializable.default];
    }
  }], [{
    key: "toMultiPolygonArray",
    value: function toMultiPolygonArray(multiPolygons) {
      var multiPolygonArray = new Array(multiPolygons.size()).fill(null);
      return multiPolygons.toArray(multiPolygonArray);
    }
  }, {
    key: "toGeometryArray",
    value: function toGeometryArray(geometries) {
      if (geometries === null) return null;
      var geometryArray = new Array(geometries.size()).fill(null);
      return geometries.toArray(geometryArray);
    }
  }, {
    key: "getDefaultCoordinateSequenceFactory",
    value: function getDefaultCoordinateSequenceFactory() {
      return _CoordinateArraySequenceFactory.default.instance();
    }
  }, {
    key: "toMultiLineStringArray",
    value: function toMultiLineStringArray(multiLineStrings) {
      var multiLineStringArray = new Array(multiLineStrings.size()).fill(null);
      return multiLineStrings.toArray(multiLineStringArray);
    }
  }, {
    key: "toLineStringArray",
    value: function toLineStringArray(lineStrings) {
      var lineStringArray = new Array(lineStrings.size()).fill(null);
      return lineStrings.toArray(lineStringArray);
    }
  }, {
    key: "toMultiPointArray",
    value: function toMultiPointArray(multiPoints) {
      var multiPointArray = new Array(multiPoints.size()).fill(null);
      return multiPoints.toArray(multiPointArray);
    }
  }, {
    key: "toLinearRingArray",
    value: function toLinearRingArray(linearRings) {
      var linearRingArray = new Array(linearRings.size()).fill(null);
      return linearRings.toArray(linearRingArray);
    }
  }, {
    key: "toPointArray",
    value: function toPointArray(points) {
      var pointArray = new Array(points.size()).fill(null);
      return points.toArray(pointArray);
    }
  }, {
    key: "toPolygonArray",
    value: function toPolygonArray(polygons) {
      var polygonArray = new Array(polygons.size()).fill(null);
      return polygons.toArray(polygonArray);
    }
  }, {
    key: "createPointFromInternalCoord",
    value: function createPointFromInternalCoord(coord, exemplar) {
      exemplar.getPrecisionModel().makePrecise(coord);
      return exemplar.getFactory().createPoint(coord);
    }
  }]);

  return GeometryFactory;
}();

exports.default = GeometryFactory;

GeometryFactory.constructor_ = function () {
  this._precisionModel = null;
  this._coordinateSequenceFactory = null;
  this._SRID = null;

  if (arguments.length === 0) {
    GeometryFactory.constructor_.call(this, new _PrecisionModel.default(), 0);
  } else if (arguments.length === 1) {
    if ((0, _hasInterface.default)(arguments[0], _CoordinateSequenceFactory.default)) {
      var coordinateSequenceFactory = arguments[0];
      GeometryFactory.constructor_.call(this, new _PrecisionModel.default(), 0, coordinateSequenceFactory);
    } else if (arguments[0] instanceof _PrecisionModel.default) {
      var precisionModel = arguments[0];
      GeometryFactory.constructor_.call(this, precisionModel, 0, GeometryFactory.getDefaultCoordinateSequenceFactory());
    }
  } else if (arguments.length === 2) {
    var _precisionModel = arguments[0],
        SRID = arguments[1];
    GeometryFactory.constructor_.call(this, _precisionModel, SRID, GeometryFactory.getDefaultCoordinateSequenceFactory());
  } else if (arguments.length === 3) {
    var _precisionModel2 = arguments[0],
        _SRID = arguments[1],
        _coordinateSequenceFactory = arguments[2];
    this._precisionModel = _precisionModel2;
    this._coordinateSequenceFactory = _coordinateSequenceFactory;
    this._SRID = _SRID;
  }
};

GeometryFactory.serialVersionUID = -6820524753094095635;